import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { NewBreadcrumb as BreadcrumbComponent } from '../../../components'
import {
	Row,
	Col,
	Button,
	FormGroup,
	FormControl,
	ControlLabel,
	Alert,
} from 'react-bootstrap'
import { renderAlert, clearAlert } from '../../../redux/actions/alertsActions'
import { addPostup } from '../../../redux/actions/postupActions'
import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

let isLoading = 'false'

class Add extends Component {
	static contextTypes = {
		router: PropTypes.object,
	}

	constructor(props) {
		super(props)
		this.state = {
			path: ['Home', 'Manage Postup', 'Add New'],
			links: ['home', 'postup/list', 'postup/add'],
			title: '',
			cityList: [],
			cityID: '',
			cityIDError: '',
		}
		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleDismiss = this.handleDismiss.bind(this)
		this.handleShow = this.handleShow.bind(this)
		this.onSelectedCity = this.onSelectedCity.bind(this)
		this.Clear = this.Clear.bind(this)
	}

	handleDismiss() {
		this.setState({ messageShow: false })
	}

	handleShow() {
		this.setState({ messageShow: true })
	}

	validate = e => {
		let isError = false

		if (!this.state.title) {
			isError = true
			this.setState({ titleError: 'red' })
		}

		if (!this.state.cityID) {
			isError = true
			this.setState({ cityIDError: 'red' })
		}

		return isError
	}

	handleSubmit = e => {
		e.preventDefault()
		let isError = this.validate()
		if (!isError) {
			isLoading = 'true'
			const formData = new FormData()
			formData.append('title', this.state.title)
			formData.append('cityID', this.state.cityID)
			this.props.addPostup(formData, 'postup-list/add')
		}
	}

	handleChange = e => {
		if (`${e.target.name}Error` !== '') {
			this.setState({ [`${e.target.name}Error`]: '' })
		}
		this.setState({ [e.target.name]: e.target.value })
	}

	Clear() {
		;(this.state.title = ''), (this.state.cityID = '')
	}

	onSelectedCity = e => {
		const selectedCity = e.target.value
		this.setState({
			cityID: selectedCity,
		})
		if (selectedCity) {
			this.setState({ cityIDError: '' })
		} else {
			this.setState({ cityIDError: 'red' })
		}
	}

	componentDidMount() {
		let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'))
		if (siteData.active_cities) {
			this.setState({
				cityList: siteData.active_cities,
			})
		}
	}

	componentWillMount() {
		this.props.clearAlert()
		this.handleDismiss()
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.postupResponse !== nextProps.postupResponse) {
			if (nextProps.postupResponse) {
				this.props.clearAlert()
				this.handleShow()
				if (nextProps.postupResponse.response == 'success') {
					this.Clear()
					this.props.renderAlert('success', nextProps.postupResponse.message)
				} else {
					this.props.renderAlert('danger', nextProps.postupResponse.message)
				}
				window.scrollTo(0, 0)
				isLoading = 'false'
			}
		}
		if (this.props.error !== nextProps.error) {
			if (nextProps.error) {
				this.props.clearAlert()
				this.handleShow()
				this.props.renderAlert('danger', nextProps.error)
				window.scrollTo(0, 0)
				isLoading = 'false'
			}
		}
		if (nextProps.message) {
			this.handleShow()
			this.setState({
				alertMessage: nextProps.message,
				msgType: nextProps.alertType,
			})
			isLoading = 'false'
		}
	}

	render() {
		return (
			<div className="col-lg-12 add-sub-admin">
				{isLoading == 'true' ? (
					<div className="loader">
						<p className="loading-message">
							<i>Loading...</i>
						</p>
						<div className="spinner">
							<div className="dot1" />
							<div className="dot2" />
						</div>
					</div>
				) : (
					''
				)}
				<div className="row">
					<div className="col-xs-12">
						<BreadcrumbComponent
							path={this.state.path}
							links={this.state.links}
							context={this.context}
							context={this.context}
						/>
					</div>
				</div>
				<form>
					<div className="panel">
						<header className="panel-heading">Add Postup</header>
						<div className="panel-body">
							{this.state.messageShow && this.state.alertMessage !== '' && (
								<div className="col-lg-12">
									<Alert
										bsStyle={this.state.msgType}
										onDismiss={this.handleDismiss}
									>
										<strong>Message:</strong> {this.state.alertMessage}
									</Alert>
								</div>
							)}
							<Row>
								<Col md={6} xs={12}>
									<Row>
										<Col md={12} xs={126}>
											<FormGroup>
												<ControlLabel>
													<span style={{ color: 'red' }}>*</span> Title:
												</ControlLabel>
												<FormControl
													type="text"
													placeholder="Title"
													value={this.state.title}
													name="title"
													onChange={this.handleChange}
													style={{
														borderColor: this.state.titleError,
													}}
												/>
											</FormGroup>
										</Col>
										<Col md={12} xs={126}>
											<FormGroup>
												<ControlLabel>
													<span style={{ color: 'red' }}>*</span> City:
												</ControlLabel>
												<FormControl
													componentClass="select"
													value={this.state.cityID}
													name="cityID"
													onChange={this.onSelectedCity}
													style={{
														borderColor: this.state.cityIDError,
													}}
												>
													<option value="">Choose Region/City</option>
													{this.state.cityList &&
														this.state.cityList.map((data, i) => (
															<optgroup key={i} label={data.country}>
																{data.cities &&
																	data.cities.map((city, index) => (
																		<option key={index} value={city.cityID}>
																			{city.title}
																		</option>
																	))}
															</optgroup>
														))}
												</FormControl>
											</FormGroup>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row>
								<hr />
							</Row>
							<Row>
								<Col md={12} xs={12}>
									<Button
										bsStyle="success"
										className="pull-left"
										onClick={this.handleSubmit}
									>
										Save
									</Button>
									<Button
										bsStyle="default"
										className="pull-left"
										onClick={() =>
											this.context.router.history.push('/postup/list')
										}
									>
										Cancel
									</Button>
								</Col>
							</Row>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		error: state.postupReducer.error,
		postupResponse: state.postupReducer.postupResponse,
		alertType: state.alertsReducer.alertType,
		message: state.alertsReducer.message,
	}
}

export default compose(
	withRouter,
	connect(mapStateToProps, { addPostup, renderAlert, clearAlert }, null, {
		pure: false,
	})
)(Add)


// WEBPACK FOOTER //
// ./src/app/views/admin/postup/Add.js